<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
    conversationId: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['select'],
  computed: {
    ...mapGetters({
      allLabels: 'labels/getLabels',
      conversationLabels: 'conversationLabels/getConversationLabels',
    }),
    currentLabels() {
      return this.conversationLabels(this.conversationId) || [];
    },
    items() {
      const search = (this.searchKey || '').toLowerCase();
      return this.allLabels
        .filter(label => {
          const matchesSearch = !search || label.title.toLowerCase().includes(search);
          const notAlreadyAdded = !this.currentLabels.includes(label.title);
          return matchesSearch && notAlreadyAdded;
        })
        .map(label => ({
          label: label.title,
          key: label.title,
          description: label.title,
          color: label.color,
          id: label.id,
        }));
    },
  },
  mounted() {
    this.$store.dispatch('labels/get');
  },
  methods: {
    handleSelect(item = {}) {
      const updatedLabels = [...this.currentLabels, item.label];
      this.$store
        .dispatch('conversationLabels/update', {
          conversationId: this.conversationId,
          labels: updatedLabels,
        })
        .then(() => {
          this.$emit('select', item.label);
        });
    },
  },
};
</script>

<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleSelect"
  />
</template>
